/**
 * @generated SignedSource<<641e132c0bb14fa3dfc284ee67c55e97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptReaderFragment$data = {
  readonly segments: ReadonlyArray<{
    readonly start: number;
    readonly startTimecode: string;
    readonly text: string;
  }> | null;
  readonly " $fragmentType": "TranscriptReaderFragment";
};
export type TranscriptReaderFragment$key = {
  readonly " $data"?: TranscriptReaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptReaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptReaderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetTranscriptionSegment",
      "kind": "LinkedField",
      "name": "segments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTimecode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AssetTranscription",
  "abstractKey": null
};

(node as any).hash = "201257ca8678f85564afcea96869c8a6";

export default node;
